export default function encodeRFC5987ValueChars2(str: string): string {
  return encodeURIComponent(str)
    .replace(/['()*]/g, c => `%${c.charCodeAt(0).toString(16)}`)
    .replace(/%(7C|60|5E)/g, hex => String.fromCharCode(parseInt(hex, 16)));
}
